import React from 'react';
import SideBar from '../sidebar';
import BaseComponent from '../system/base';
import UserContext from '../../context/userContext';
import Reorder from '@material-ui/icons/Reorder';
import IconButton from '@material-ui/core/IconButton';
import PubSub from 'pubsub-js';

class Banner extends BaseComponent {
  static contextType = UserContext;

  // state = {
  //   isSignedIn: undefined,
  // };

  render() {
    return (
      <React.Fragment>
        <SideBar/>
        <div style={{backgroundColor: "#1A1A1A"}}>
          {this.context.user.isSignedIn && <IconButton style={{position: "absolute", color: "white"}} onClick={() => {
            PubSub.publish('nav-toggle', true);
          }}>
            <Reorder style={{ fontSize: 30 }}/>
          </IconButton>}
          <div className="center">
            <img src="/images/content/banner/popitLogoTop.png" alt="Main Popit Logo"/>
          </div>
        </div>
        {this.props.children}
      </React.Fragment>
    );
  }
}


export default Banner


// WEBPACK FOOTER //
// ./src/components/banner/index.js